import React from 'react';
           import { FaPhone, FaMapMarkerAlt, FaEnvelope } from 'react-icons/fa';

const ContactSection = () => {
  return (
   <>
    <section
      className="page-title"
      style={{
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(images/background/3.jpg)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: 'white'
  }}
    >
      <div className="auto-container">
        <h1>Contact Us</h1>
       
      </div>
    </section>
   
    <section className="contact-section">
      <div className="auto-container">
        <div className="row clearfix">
          {/* Form Column */}
          <div className="form-column col-md-7 col-sm-12 col-xs-12">
            <div className="column-inner">
              <div className="form-title">
                <h2>Contact Form</h2>
                <div className="separator"></div>
                <div className="text">
                  Reach Out to Shree Swami Samarth PG
Our Team Is Here to Assist You

                </div>
              </div>

              {/* Contact Form */}
              <div className="contact-form">
                <form
                  id="contact-form"
                  action="https://www.brandifystudio.com/web/aizen/send.php"
                  method="post"
                >
                  <div className="row clearfix">
                    <div className="col-md-6 col-sm-6 col-xs-12 form-group">
                      <input type="text" name="name" placeholder="Your Name" required />
                    </div>

                    <div className="col-md-6 col-sm-6 col-xs-12 form-group">
                      <input type="email" name="email" placeholder="Email address" required />
                    </div>

                    <div className="col-md-6 col-sm-6 col-xs-12 form-group">
                      <input type="text" name="phone" placeholder="Phone" required />
                    </div>

                    <div className="col-md-6 col-sm-6 col-xs-12 form-group">
                      <input type="text" name="subject" placeholder="Subject" required />
                    </div>

                    <div className="col-md-12 col-sm-12 col-xs-12 form-group">
                      <textarea name="message" placeholder="Message"></textarea>
                    </div>

                    <div className="col-md-12 col-sm-12 col-xs-12 form-group">
                      <button className="theme-btn btn-style-one" type="submit" name="submit-form">
                        Send message
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              {/* End Contact Form */}
            </div>
          </div>

          {/* Info Column */}
          <div className="info-column col-md-5 col-sm-12 col-xs-12">

<ul className="list-style-two">
  <li>
    <span className="icon"><FaPhone /></span>
    <div className="info-featured">+91 9209169761</div>
  </li>

  <li>
    <span className="icon"><FaPhone /></span>
    <div className="info-featured">+91 9096665072</div>
  </li>

  <li>
    <span className="icon"><FaEnvelope /></span>
    <div className="info-featured">
      <a href="mailto:reservation@swamisamarthpg.com">
        reservation@swamisamarthpg.com
      </a>
    </div>
  </li>

  <li>
    <span className="icon"><FaMapMarkerAlt /></span>
    <div className="text-info">Address</div>
    <h3>
      Shree Swami Samarth PG<br />
       M.No. 03065, No. 258/1/3, Mukai Nagar, B.H. MRF Showroom, Pune 411057
    </h3>
  </li>
</ul>

          </div>



 <div className="map-wrapper pt-90">
    
<iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3156.176013955525!2d73.73120287423927!3d18.596449466853958!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTjCsDM1JzQ3LjIiTiA3M8KwNDQnMDEuNiJF!5e1!3m2!1sen!2sin!4v1755666696282!5m2!1sen!2sin"  width="100%"
          height="400"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        
    </div>


        </div>
      </div>
    </section>
   </>
  );
};

export default ContactSection;
